import React from 'react';
import SelectionList from '../../../shared/components/SelectionList';
import SelectionCheckbox from '../SelectionCheckbox';
import useOhtList from '@shared/hooks/useOhtList';

/**
 * @typedef {object} OhtSelectionProps
 * @property {Array<*>} [ohts]
 * @property {(ohts: Array<{ label: string, value: number | string, displayName?: string }>) => void} [setOhts]
 * @property {boolean} [includeExactMatchedOhts]
 * @property {(includeExactMatchedOhts: boolean) => void} [setIncludeExactMatchedOhts]
 */

/**
 * @param {OhtSelectionProps} props
 */
const OhtSelection = props => {
  const { ohts, setOhts, includeExactMatchedOhts, setIncludeExactMatchedOhts } = props;

  const { ohtList, ohtListLoading } = useOhtList();

  return (
    <div className='appraisal-view-customization__section'>
      <SelectionList
        id='select-oht'
        showInputEndAdornment={false}
        allowAutocomplete={false}
        label='OHT(s)'
        onSelectHandler={setOhts}
        selectedValue={ohts}
        list={ohtList}
        placeholder='Select OHT(s)'
        multiSelect={true}
        loading={ohtListLoading}
      />
      <SelectionCheckbox
        id='select-include-exact-ohts'
        label='Only display results that match the selection exactly.'
        disabled={!ohts.length}
        checked={includeExactMatchedOhts}
        setChecked={setIncludeExactMatchedOhts}
      />
    </div>
  );
};

export default OhtSelection;
